// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__vbQko","container":"accordion_container__Q6e6I","expanded":"accordion_expanded__gzqmt","content":"accordion_content__zl9fW"};